import React, { useState } from 'react';
import { withStyles } from '@material-ui/core/styles';
import {
  Grid,
  Button,
  Paper,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  CircularProgress,
  TablePagination,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import MembershipPerksWrapper from './membership-perks-wrapper';
import { Link } from 'react-router-dom';
import { useGetMembershipPerks, useDeleteMembershipPerk } from 'api/membership-perks';
import MemebershipPerkTableRow from './membership-perks-table-row';

const MemebershipPerks = ({ ...props }) => {
  const [params, setParams] = useState({ page_index: 0, page_size: 25 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedMembershipPerk, setSelectedMembershipPerk] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const { isLoading, data: membershipPerks, refetch } = useGetMembershipPerks(params);
  const { mutate: deleteMembershipPerk } = useDeleteMembershipPerk({ onSuccess: refetch });

  function handleChangePage(_, page) {
    setParams({ ...params, page_index: page });
  }

  function handleChangeRowsPerPage({ target: { value } }) {
    setParams({ ...params, page_index: 0, page_size: value });
  }

  function confirmDelete(id) {
    setSelectedMembershipPerk(membershipPerks?.results.find(mp => mp.id === id));
    setIsDialogOpen(true);
  }

  async function doDelete() {
    setIsDeleting(true);
    await deleteMembershipPerk(selectedMembershipPerk.id);
    setIsDialogOpen(false);
    setIsDeleting(false);
  }

  const { classes } = props;
  return (
    <MembershipPerksWrapper>
      <Grid item xs={12} className={classes.rightActionContianer}>
        <Link className={classes.actionButton} to={'/membership-perks/create'}>
          <Button variant="contained">Create Membership Perk</Button>
        </Link>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper}>
          {isLoading && <CircularProgress />}
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Title</TableCell>
                <TableCell>Image</TableCell>
                <TableCell>Tier</TableCell>
                <TableCell>Description</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={params.page_size}
                  count={membershipPerks?.total || 0}
                  page={params.page_index}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
              {membershipPerks?.results?.map(membershipPerk => (
                <MemebershipPerkTableRow
                  key={membershipPerk.id}
                  membershipPerk={membershipPerk}
                  confirmDeleleteMembershipPerk={confirmDelete}
                  isDeletsing={isDeleting}
                />
              ))}
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[25, 50, 100]}
                  rowsPerPage={params.page_size}
                  count={membershipPerks?.total || 0}
                  page={params.page_index}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      <Dialog open={isDialogOpen}>
        <DialogContent>
          <div>{`Are you sure you want to delete perk with title ${selectedMembershipPerk?.title}`}</div>
          <Button variant="contained" size="small" onClick={doDelete}>
            Continue
          </Button>
          <Button variant="contained" size="small" onClick={() => setIsDialogOpen(false)}>
            Cancel
          </Button>
        </DialogContent>
      </Dialog>
    </MembershipPerksWrapper>
  );
};

const styles = theme => ({
  actionButton: {
    marginRight: theme.spacing(1),
  },
  rightActionContianer: {
    textAlign: 'right',
  },
});

export default withStyles(styles)(MemebershipPerks);
